export enum GroundSlotTypeEnum {
  HEADQUATERS = 'headquaters',
  PUBLIC_RELATIONS = 'public_relations',
  OFFICE = 'office',
  TRAINING = 'training',
  SCOUTING = 'scouting',
  YOUTH = 'youth',
}

export enum EffectTypeEnum {
  STAFF_MEMBER_SLOTS = 'staff_member_slots',
  NEGOTIATION_PROGRESS = 'negotiation_progress',
  TRAINING_PROGRESS = 'training_progress',
  YOUTH_TRAINING_PROGRESS = 'youth_training_progress',
  SCOUTING_PROGRESS = 'scouting_progress',
  SPONSORING_BASE_OFFER = 'sponsoring_base_offer',
  SPECTATORS = 'spectators',
}